import { Helmet } from "react-helmet";
import favIcon from "../../assets/images/fav_icon.ico";
const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        {/* meta tag*/}
        <meta charset="utf-8" />
        <title>Coderblock Lands: mint your parcels</title>
        <meta
          name="description"
          content="Get your lands in Coderblock: the blockchain-based metaverse where you can create your own story."
        />
        <meta
          name="apple-mobile-web-app-title"
          content="Coderblock Lands: mint your parcels"
        />

        <meta
          property="og:title"
          content="Coderblock Lands: mint your parcels"
        />

        <meta
          property="og:image"
          content="https://coderblock-assets.akamaized.net/cdn/assets/img/opengraph-mint-page.jpeg"
        />

        <meta
          property="og:image:alt"
          content="Coderblock Lands: mint your parcels"
        />

        <meta
          property="og:description"
          content="Get your lands in Coderblock: the blockchain-based metaverse where you can create your own story."
        />

        <meta
          name="twitter:title"
          content="Coderblock Lands: mint your parcels"
        />

        <meta
          name="twitter:description"
          content="Get your lands in Coderblock: the blockchain-based metaverse where you can create your own story."
        />

        <meta
          itemprop="description"
          content="Get your lands in Coderblock: the blockchain-based metaverse where you can create your own story."
        />

        <meta
          name="keywords"
          content="Coderblock, metaverse, lands, NFT, blockchain, avatar, virtual world"
        ></meta>
        <meta name="robots" content="noindex,nofollow" />

        {/* responsive tag */}
        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        {/* Bootstrap Latest compiled and minified CSS  */}
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
          crossorigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Bakbak+One&family=Inter:wght@300;400&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="https://coderblock-assets.akamaized.net/cdn/assets/img/favicon/apple-touch-icon.png?v=2"
        />
        <link
          rel="icon"
          type="image/png"
          href="https://coderblock-assets.akamaized.net/cdn/assets/img/favicon/favicon-32x32.png?v=2"
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href="https://coderblock-assets.akamaized.net/cdn/assets/img/favicon/favicon-16x16.png?v=2"
          sizes="16x16"
        />
        <link
          rel="manifest"
          href="https://coderblock-assets.akamaized.net/cdn/assets/img/favicon/manifest.json?v=2"
        />
        <link
          rel="mask-icon"
          href="https://coderblock-assets.akamaized.net/cdn/assets/img/favicon/safari-pinned-tab.svg?v=2"
          color="#23c189"
        />
        <link
          rel="shortcut icon"
          href="https://coderblock-assets.akamaized.net/cdn/assets/img/favicon/favicon.ico?v=2"
        />
      </Helmet>
      {children}
    </>
  );
};

export default Layout;
